
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import { Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { IAnnotation } from '@/types';
import { log } from '../../plugins/logger';

@Component
export default class PredictDialog extends Vue {
  @Prop(Boolean)
  value!: boolean;
  @Prop(Object)
  data!: IAnnotation;

  state: 'processing' | 'codhResult' | 'toppanResult' = 'processing';
  engine = 'codh';
  codhResults = [];

  toppanResults: { Candidates: string[]; Distances: number[] } = {
    Candidates: [],
    Distances: [],
  };

  get soramaru() {
    if (this.state === 'processing') {
      return 'img/soramaru/09_closed.png';
    } else if (this.state === 'codhResult' || this.state === 'toppanResult') {
      return 'img/soramaru/08_fun.png';
    }
  }

  get show() {
    return this.value;
  }
  set show(value) {
    this.init();
    this.$emit('input', value);
  }

  links(str: string){
    const charCode = str.charCodeAt(0).toString(16).toUpperCase()
    const codhLink = `http://codh.rois.ac.jp/char-shape/unicode/U+${charCode}/`
    const hensanjoLink = `http://clioapi.hi.u-tokyo.ac.jp/ships/ZClient/W34/z_list.php?title=${str}&resourcetype=0`
    return `<a href="${codhLink}" target="_blnak">CODH</a> <a href="${hensanjoLink}" target="_blnak">電子くずし字辞典</a>`
  }

  @Watch('data.rect.url')
  init() {
    if (!this.show) return;
    this.state = 'processing';
    this.toppanResults = {
      Candidates: [],
      Distances: [],
    };
    this.codhResults = [];
  }

  @Watch('data.rect.url')
  predict() {
    if (!this.show) return;
    log('PREDICT', { engine: this.engine, anno: this.data });
    this.state = 'processing';
    if (this.engine === 'codh') {
      this.predictWithCODHEngine();
    } else {
      this.predictWithToppanEngine();
    }
  }

  async predictWithCODHEngine() {
    const url = this.data.rect.url;
    const img = await this.getImage(url, 96);
    const results = await (<any>window).predict(img);
    this.codhResults = results;
    this.state = 'codhResult';
  }

  getImage(src: string, size?: number): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.crossOrigin = 'anonymous';
      img.src = src;
      if (size) {
        img.width = size;
        img.height = size;
      }
    });
  }

  async predictWithToppanEngine() {
    const url = this.data.rect.url;
    const img = await this.getImage(url);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(img, 0, 0);
    const Img = canvas
      .toDataURL('image/png')
      .replace('data:image/png;base64,', '');
    let params = new URLSearchParams();
    const X = 0;
    const Y = 0;
    const W = img.width;
    const H = img.height;
    const DatasetClass = 'PMJT';
    const Direction = 1;
    const data = [{ Img, X, Y, W, H, DatasetClass, Direction }];
    const api = 'https://ik1-344-32468.vs.sakura.ne.jp/toppan/proxy';
    //const api = 'http://localhost:4567/proxy';
    //const api = 'http://153.126.217.222/proxy';
    const resp = await axios.post(api, data);
    this.toppanResults = resp.data[0];
    console.log(resp.data[0]);
    this.state = 'toppanResult';
  }

  // see https://github.com/axios/axios/issues/513
  async imgUrlToBase64(url: string): Promise<string> {
    const resp = await axios.get(url, { responseType: 'arraybuffer' });
    let image = btoa(
      new Uint8Array(resp.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        '',
      ),
    );
    return `data:${resp.headers['content-type'].toLowerCase()};base64,${image}`;
  }
}
